import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Modal, Button, Input } from "@/components/common";
import styles from "./DepositEditModal.module.css";
export const DepositEditModal = ({ isOpen, onClose, currentValue, onSave, }) => {
    const [value, setValue] = useState(currentValue.toString());
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (isOpen) {
            setValue(currentValue.toString());
            setError(null);
        }
    }, [isOpen, currentValue]);
    const handleSave = async () => {
        const num = Number(value);
        if (Number.isNaN(num) || num < 0 || num > 100) {
            setError("Please enter a value between 0 and 100");
            return;
        }
        setSaving(true);
        setError(null);
        try {
            await onSave(num);
            onClose();
        }
        catch {
            setError("Failed to save deposit");
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, title: "Edit Default Deposit", children: _jsxs("div", { className: styles.content, children: [_jsx(Input, { label: "Default deposit percentage", type: "number", min: 0, max: 100, value: value, onChange: (e) => setValue(e.target.value), error: error ?? undefined }), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { variant: "secondary", onClick: onClose, disabled: saving, children: "Cancel" }), _jsx(Button, { onClick: handleSave, loading: saving, disabled: saving, children: "Save" })] })] }) }));
};
